import toTitleCase from "./toTitleCase";

export default function snakeToTitleCase(text: string): string {
  return toTitleCase(text.replaceAll("_", " "));
}
